const STATE_NAME_TO_ABBREVIATION: Record<string, string> = {
  'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
  'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
  'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
  'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
  'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
  'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
  'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH',
  'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
  'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
  'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY',
  'district of columbia': 'DC'
};

const VALID_STATE_ABBREVIATIONS = new Set(Object.values(STATE_NAME_TO_ABBREVIATION));

export const extractStateFromAddress = (address?: string): string => {
  const maxChunkIndex: number = 3;
  const stateDefaultLength: number = 2;
  const stateIndex: number  = 2;

  if (typeof address !== 'string' || !address)
    return '';

  const chunks = address.split(',').map(e => e.trim());
  
  if (chunks.length < maxChunkIndex)
    return '';

  const stateChunk = chunks[stateIndex].toLowerCase();
  
  if (stateChunk.length === stateDefaultLength && VALID_STATE_ABBREVIATIONS.has(stateChunk.toUpperCase())) {
    return stateChunk.toUpperCase();
  }
  
  if (STATE_NAME_TO_ABBREVIATION[stateChunk]) {
    return STATE_NAME_TO_ABBREVIATION[stateChunk];
  }

  if (stateChunk.length === stateDefaultLength) {
    return stateChunk.toUpperCase();
  }

  return '';
};

export const extractCityFromAddress = (address?: string): string => {
  const minChunksRequired: number = 3;
  const cityIndex: number = 1;
  
  if (typeof address !== 'string' || !address)
    return '';

  let chunks = address.split(',')
    .map(e => e.trim());

  if (chunks.length < minChunksRequired)
    return '';

  return chunks[cityIndex];
};
